<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { requestNotificationPermission } from './utils/notify.js'
export default {
  name: 'App',
  mounted() {
    requestNotificationPermission()
  }
}

</script>

